import * as z from "zod";

declare global { const site_options: SiteOptions; }

export const siteOptionsSchema = z.object({
  name: z.string(),
  description: z.string(),
  main_menu_items: z.array(navMenuItemSchema),
  footer_left_side: z.string().optional(),
  footer_center: z.string().optional(),
  social_media: z.array(z.object({
    url: z.string(),
  })).optional(),
});
export type SiteOptions = z.infer<typeof siteOptionsSchema>;
